export default "__VITE_ASSET__0fa601d7__"